
import React, { useState, useEffect, useRef } from "react";
import { serviceUrl } from "../../config";
import "./ScheduleBatch.scss";
import {
  ScheduleEntryAdd,
  ScheduleEntryAdd3,
  AddTransFileRecs,
  ScheduleJobList6,
} from "../../util/API/batch";
import { getBaseUrl } from "../../util/utilfunctions/getbaseurl";
import { useSelector } from "react-redux";
import Papa from "papaparse";
import PinPad from "../PinPad/PinPad";
import { Box, Typography, CircularProgress } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import * as XLSX from "xlsx";
import { commonRunQuery } from "../../util/API/loans";
const PAYROLL_CATEGORY_ID = "33";

function ScheduleBatch({ batchList, userPermissions }) {
  console.log('batch list------------>', JSON.stringify(batchList))
  const [uploadId, setUploadId] = useState("0");
  const [selectedDateTime, setSelectedDateTime] = useState("");
  const [csvData, setCsvData] = useState(null);
  const [uploadLocation, setUploadLocation] = useState("");
  const [fileName, setFileName] = useState("");
  const [originalFileName, setOriginalFileName] = useState("");
  const [notes, setNotes] = useState("");
  const [scheduleBatch, setScheduleBatch] = useState(true);
  const [succuessfulSchedule, setSuccuessfulSchedule] = useState(false);
  const [invalidEmails, setInvalidEmails] = useState([]);
  const [showPinPad, setShowPinPad] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [pinProcessing, setPinProcessing] = useState(false);
  // ── payroll-only submit state (ScheduleEntryAdd3 + AddTransFileRecs flow) ──
  const [totalAmount, setTotalAmount] = useState("0.00");
  const [uploadProgress, setUploadProgress] = useState({
    isUploading: false,
    processed: 0,
    total: 0,
    message: "",
  });
  const TEMPLATE_HEADERS = [
    "first_name",
    "last_name",
    "birthdate",
    "accountno",
    "address",
    "phone_number",
    "alternate_number",
    "email",
    "country_code",
    "currency_code",
    "amount",
    "comment",
    "purpose_of_account",
  ];
  const TEMPLATE_HEADER_SET = new Set(TEMPLATE_HEADERS);
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "success",
    header: "Success",
  });

  // ── ref to the hidden file input so "Change File" can re-trigger it ──
  const fileInputRef = useRef(null);
  const isSubmittingRef = useRef(false);
  console.log("uploadId==============", uploadId);

  const templateUrl = getBaseUrl(serviceUrl);
  const merchantInfo = useSelector((state) => state.login.user);

  const getTemplateHeader = (header) =>
    String(header || "").replace(/^\uFEFF/, "");

  const getTemplateHeaderErrors = (headers) => {
    const templateHeaders = headers.map(getTemplateHeader);
    const unexpected = templateHeaders.filter(
      (header) => !TEMPLATE_HEADER_SET.has(header),
    );
    const missing = TEMPLATE_HEADERS.filter(
      (header) => !templateHeaders.includes(header),
    );
    const duplicates = templateHeaders.filter(
      (header, index) => templateHeaders.indexOf(header) !== index,
    );
    return {
      unexpected: [...new Set(unexpected)],
      missing,
      duplicates: [...new Set(duplicates)],
    };
  };

  const isExactAccountNumberHeader = (header) =>
    String(header || "").replace(/^\uFEFF/, "") === "accountno";

  const isValidPersonName = (value) =>
    /^[\p{L}\p{M} .'-]+$/u.test(String(value).trim());
  const isValidAddress = (value) =>
    /^[\p{L}\p{M}\p{N} ,.'\/#-]+$/u.test(String(value).trim());

  const handleBatchTypeChange = (event) => {
    setUploadId(event.target.value);
    const uploadLocation = getUploadLocation(event.target.value);
    setUploadLocation(uploadLocation);
  };

  const handleChange = (e) => {
    setNotes(e.target.value);
  };

  const handleDateTimeChange = (event) => {
    setSelectedDateTime(event.target.value);
  };
   const handleDownloadTemplate = () => {
      const wb = XLSX.utils.book_new();
  
      const headers = [
        "first_name",
        "last_name",
        "birthdate",
        "accountno",
        "address",
        "phone_number",
        "alternate_number",
        "email",
        "country_code",
        "currency_code",
        "amount",
        "comment",
        "purpose_of_account",
      ];
  
      const exampleRows = [
        [
          "John",
          "Doe",
          "1990-01-15",
          "1234567890",
          "123 Main St Apt 4B",
          "6471234567",
          "",
          "john.doe@4pay.ca",
          "TCA",
          "USD",
          "0.00",
          "Monthly salary",
          "2",
        ],
      ];
  
      const wsData = [headers, ...exampleRows];
      const ws = XLSX.utils.aoa_to_sheet(wsData);
  
      ws["!cols"] = [
        { wch: 16 },
        { wch: 16 },
        { wch: 14 },
        { wch: 14 },
        { wch: 26 },
        { wch: 20 },
        { wch: 20 },
        { wch: 26 },
        { wch: 14 },
        { wch: 14 },
        { wch: 12 },
        { wch: 22 },
        { wch: 20 },
      ];
  
      XLSX.utils.book_append_sheet(wb, ws, "Payroll Data");
      XLSX.writeFile(wb, "batch_template.xlsx");
  
      setAlert({
        open: true,
        severity: "success",
        header: "Template Downloaded",
        message:
          "batch_template.xlsx downloaded. Fill it in Excel, save as CSV, then upload!",
      });
    };
  useEffect(() => {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localTime = new Date(now.getTime() - offset * 60 * 1000)
      .toISOString()
      .slice(0, 16);
    setSelectedDateTime(localTime);
  }, []);

  useEffect(() => {
    console.log(uploadId, fileName, invalidEmails);
    if (uploadId != 0 && fileName) {
      setScheduleBatch(false);
    }
  }, [fileName, uploadId, invalidEmails]);

  // ── payroll-only: keep a running total amount for ScheduleEntryAdd3 ──
  useEffect(() => {
    if (csvData && csvData.length > 0) {
      const total = csvData.reduce((sum, row) => {
        const amountKey = Object.keys(row).find((k) =>
          k.toLowerCase().includes("amount"),
        );
        const amt = amountKey ? parseFloat(row[amountKey] || 0) : 0;
        return sum + (isNaN(amt) ? 0 : amt);
      }, 0);
      setTotalAmount(total.toFixed(2));
    } else {
      setTotalAmount("0.00");
    }
  }, [csvData, uploadId]);

  function getUploadLocation(categoryId) {
    const records = batchList;
    for (const record of records) {
      const categoryid = record.batchfilecategories.categoryid;
      if (categoryid === categoryId) {
        const uploadlocation = record.batchfilecategories.uploadlocation;
        return uploadlocation;
      }
    }
    return null;
  }

  function isValidEmail(email) {
    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(String(email).toLowerCase());
  }

  const getPhoneEmailMismatchErrors = async (data) => {
    const contacts = data
      .map((row, index) => {
        const accountKey = Object.keys(row).find(isExactAccountNumberHeader);
        const phoneKey = Object.keys(row).find(
          (key) =>
            key.toLowerCase().includes("phone") ||
            key.toLowerCase().includes("mobile"),
        );
        const emailKey = Object.keys(row).find((key) =>
          key.toLowerCase().includes("email"),
        );
        return {
          rowNum: index + 2,
          accountno: accountKey ? String(row[accountKey] || "").trim() : "",
          phone: phoneKey ? String(row[phoneKey] || "").trim() : "",
          email: emailKey ? String(row[emailKey] || "").trim() : "",
        };
      })
      .filter(({ phone, email }) => phone && email);

    const phones = [...new Set(contacts.map(({ phone }) => phone))];
    if (phones.length === 0) return [];

    const results = await Promise.all(
      phones.map(async (phone) => {
        const response = await commonRunQuery(384, phone);
        if (
          !response?.data?.header ||
          String(response.data.header.callStatus) === "-1"
        ) {
          throw new Error("Unable to check whether the phone number has an existing account.");
        }

        // Query 384 returns phone_account_exists when the phone belongs to a phone-based account.
        const responseRecord = response?.data?.body?.record;
        const rawRecord =
          responseRecord?.b ?? responseRecord?.dir ?? responseRecord?.record ?? responseRecord;
        const records = Array.isArray(rawRecord)
          ? rawRecord
          : rawRecord
            ? [rawRecord]
            : [];
        return [phone, String(records[0]?.phone_account_exists || "") === "1"];
      }),
    );

    const phoneAccountExistsByPhone = new Map(results);
    return contacts
      .filter(({ phone }) => phoneAccountExistsByPhone.get(phone))
      .map(({ rowNum }) => ({
        message:
          `Row ${rowNum}: this phone number is already linked to an account. Please remove email from the batch record.`,
      }));
  };

  const getAccountContactMismatchErrors = async (data) => {
    const contacts = data
      .map((row, index) => {
        const accountKey = Object.keys(row).find(isExactAccountNumberHeader);
        const emailKey = Object.keys(row).find((key) =>
          key.toLowerCase().includes("email"),
        );
        const phoneKey = Object.keys(row).find(
          (key) =>
            key.toLowerCase().includes("phone") ||
            key.toLowerCase().includes("mobile"),
        );
        return {
          rowNum: index + 2,
          accountno: accountKey ? String(row[accountKey] || "").trim() : "",
          email: emailKey ? String(row[emailKey] || "").trim() : "",
          phone: phoneKey ? String(row[phoneKey] || "").trim() : "",
        };
      })
      // Account number remains optional. Rows without one do not use Query 385.
      .filter(({ accountno }) => accountno);

    const accountNumbers = [...new Set(contacts.map(({ accountno }) => accountno))];
    if (accountNumbers.length === 0) return [];

    const results = await Promise.all(
      accountNumbers.map(async (accountno) => {
        const response = await commonRunQuery(385, accountno);
        if (
          !response?.data?.header ||
          String(response.data.header.callStatus) === "-1"
        ) {
          throw new Error("Unable to retrieve the existing account details.");
        }

        // Query 385 returns the selected directory row as body.record.dir.
        const responseRecord = response?.data?.body?.record;
        const rawRecord =
          responseRecord?.b ?? responseRecord?.dir ?? responseRecord?.record ?? responseRecord;
        const records = Array.isArray(rawRecord)
          ? rawRecord
          : rawRecord
            ? [rawRecord]
            : [];
        return [accountno, records];
      }),
    );

    const recordsByAccount = new Map(results);
    const normalizeEmail = (value) => String(value || "").trim().toLowerCase();
    const normalizePhone = (value) => String(value || "").replace(/\D/g, "");

    return contacts.flatMap(({ rowNum, accountno, email, phone }) => {
      const records = recordsByAccount.get(accountno) || [];
      if (records.length === 0) {
        return [{
          message: `Row ${rowNum}: account number "${accountno}" was not found in the active account records.`,
        }];
      }
      if (records.length > 1) {
        return [{
          message: `Row ${rowNum}: account number "${accountno}" is linked to multiple active accounts. Please contact support.`,
        }];
      }

      const record = records[0];
      const accountEmail = normalizeEmail(record.emailAddress);
      const accountPhone = normalizePhone(record.phoneno);
      const suppliedPhone = normalizePhone(phone);
      const phoneMatches =
        !suppliedPhone ||
        (accountPhone
          ? accountPhone === suppliedPhone
          : accountEmail === `1${suppliedPhone}@4pay.ph`);
      const emailMatches = !email || normalizeEmail(email) === accountEmail;

      if (emailMatches && phoneMatches) return [];
      return [{
        message:
          `Row ${rowNum}: account number and contact details do not match the existing account information. ` +
          "Please correct the email or phone number and upload again.",
      }];
    });
  };

  const getValidationReferenceData = async () => {
    const [currencyResponse, countryResponse] = await Promise.all([
      commonRunQuery(386, ""),
      commonRunQuery(387, ""),
    ]);

    if (
      String(currencyResponse?.data?.header?.callStatus) !== "1" ||
      String(countryResponse?.data?.header?.callStatus) !== "1"
    ) {
      throw new Error("Could not load payroll validation reference data.");
    }

    const getRows = (response, fieldName) => {
      const collect = (value) => {
        if (Array.isArray(value)) return value.flatMap(collect);
        if (!value || typeof value !== "object") return [];
        if (Object.prototype.hasOwnProperty.call(value, fieldName)) return [value];
        return Object.values(value).flatMap(collect);
      };
      return collect(response?.data?.body?.record);
    };

    const validCurrencies = new Set(
      getRows(currencyResponse, "currency_codes")
        .flatMap(({ currency_codes }) => String(currency_codes || "").split(","))
        .map((code) => code.trim().toUpperCase())
        .filter(Boolean),
    );
    const validCountryCodes = new Set(
      getRows(countryResponse, "country_code")
        .map(({ country_code }) => String(country_code || "").trim().toUpperCase())
        .filter(Boolean),
    );

    if (validCurrencies.size === 0 || validCountryCodes.size === 0) {
      throw new Error("Payroll validation reference data is empty.");
    }

    return { validCurrencies, validCountryCodes };
  };

  const validateCsvData = (data, referenceData) => {
    const { validCurrencies, validCountryCodes } = referenceData;
     if (uploadId === "21" || uploadId === "2") {
    return [];
  }
    const flatErrors = [];

    data.forEach((row, index) => {
      const rowNum = index + 2;

      const firstNameKey = Object.keys(row).find(
        (key) =>
          (key.toLowerCase().includes("first") &&
            key.toLowerCase().includes("name")) ||
          key.toLowerCase() === "first_name"
      );
      const lastNameKey = Object.keys(row).find(
        (key) =>
          (key.toLowerCase().includes("last") &&
            key.toLowerCase().includes("name")) ||
          key.toLowerCase() === "last_name"
      );
      const currencyKey = Object.keys(row).find(
        (key) =>
          key.toLowerCase().includes("currency") ||
          key.toLowerCase() === "currency_code",
      );
      const countryKey = Object.keys(row).find(
        (key) =>
          key.toLowerCase().includes("country") ||
          key.toLowerCase() === "country_code",
      );
      const phoneKey = Object.keys(row).find(
        (key) =>
          key.toLowerCase().includes("phone") ||
          key.toLowerCase().includes("mobile") ||
          key.toLowerCase() === "alternate_number",
      );
      const emailKey = Object.keys(row).find((key) =>
        key.toLowerCase().includes("email"),
      );
         const purposeKey = Object.keys(row).find(
        (key) =>
          key.toLowerCase().includes("purpose") ||
          key.toLowerCase() === "purpose_of_account",
      );
       const purpose_of_account = purposeKey
        ? (row[purposeKey] || "").trim()
        : "" || "SALARY";
      const first_name = firstNameKey ? (row[firstNameKey] || "").trim() : "";
      const last_name = lastNameKey ? (row[lastNameKey] || "").trim() : "";
      const address = String(row.address || "").trim();
      const currency_code = currencyKey ? (row[currencyKey] || "").trim() : "";
      const country_code = countryKey ? (row[countryKey] || "").trim() : "";
      const phone_number = phoneKey ? (row[phoneKey] || "").trim() : "";
      const email = emailKey ? (row[emailKey] || "").trim() : "";
      const accountNoKey = Object.keys(row).find(isExactAccountNumberHeader);
      const accountno = accountNoKey ? String(row[accountNoKey] || "").trim() : "";
      // const currency_code = currencyKey ? (row[currencyKey] || "").trim() : "";
      const issues = [];
      if (!first_name) issues.push("First name is required");
      if (!last_name) issues.push("Last name is required");
      if (first_name && !isValidPersonName(first_name)) {
        issues.push("First name contains unsupported characters");
      }
      if (last_name && !isValidPersonName(last_name)) {
        issues.push("Last name contains unsupported characters");
      }
      if (address && !isValidAddress(address)) {
        issues.push("Address contains unsupported characters");
      }
      if (accountno && !/^\d+$/.test(accountno)) {
        issues.push("Account number must contain only whole-number digits");
      }
      if (!currency_code) {
        issues.push("Currency code is required (e.g. USD, CAD, TZS, PKR)");
      } else if (!validCurrencies.has(currency_code)) {
        issues.push(
          `Unsupported currency code "${currency_code}". ` +
            `Allowed: ${Array.from(validCurrencies).sort().join(", ")}`,
        );
      }
      if (!country_code) {
        issues.push(
          "Country code is required (3-letter code, e.g. CAN, USA, IND)",
        );
      } else {
        const normalizedCountryCode = country_code.toUpperCase();
        if (normalizedCountryCode.length !== 3) {
          issues.push(
            `Country code must be exactly 3 characters (found: "${country_code}")`,
          );
        } else if (!validCountryCodes.has(normalizedCountryCode)) {
          issues.push(`Invalid country code "${country_code}".`);
        }
      }
      if (email && !isValidEmail(email)) {
        issues.push("Email must be in a valid format");
      }
      if (phone_number && !/^\d{10}$/.test(phone_number)) {
        issues.push(
          "Phone number must contain exactly 10 digits (no spaces or special characters).",
        );
      }
      
const VALID_PURPOSES = new Set(["1", "2", "3"]);

if (!purpose_of_account) {
  issues.push("Purpose of account is required");
} else if (!/^\d+$/.test(purpose_of_account)) {
  issues.push("Purpose of account must contain only numeric values");
} else if (!VALID_PURPOSES.has(purpose_of_account)) {
  issues.push(
    `Invalid purpose_of_account "${purpose_of_account}". Only values 1, 2 and 3 are accepted.`
  );
}

//       if (!purpose_of_account) {
//   issues.push("Purpose of account is required");
// } else if (!/^\d+$/.test(purpose_of_account)) {
//   issues.push("Purpose of account must contain only numeric values");
// } else if (purpose_of_account !== "1" &&  purpose_of_account !== "2" &&  purpose_of_account !== "3") {
//   issues.push(
//     `Invalid purpose_of_account "${purpose_of_account}". Only value 1,2 and 3 is accepted.`,
//   );
// }
   
      if (issues.length > 0) {
        flatErrors.push({
          message: `Row ${rowNum} has these issues: ${issues.join(", ")}`,
        });
      }
    });

    return flatErrors;
  };

  // const submitBatch = async (e, PIN) => {
  //   setSuccuessfulSchedule(false);
    
  //   // ── Payroll category: use ScheduleEntryAdd3 + AddTransFileRecs workflow ──
  //   if (uploadId === PAYROLL_CATEGORY_ID) {
  //     await submitPayrollStyleBatch(PIN);
  //     return;
  //   }

  //   // ── All other categories: original ScheduleEntryAdd workflow (unchanged) ──
  //   if (fileName.split(".")[1] === "zip") {
  //     let response = await ScheduleEntryAdd(
  //       merchantInfo.id,
  //       selectedDateTime,
  //       fileName,
  //       uploadLocation,
  //       uploadId,
  //       1,
  //       notes,
  //       PIN
  //     );
  //     if (response.callStatus == 1) {
  //       setUploadId("0");
  //       setSuccuessfulSchedule(true);
  //     } else {
  //       console.log("error---------", response);
  //     }
  //     setScheduleBatch(true);
  //     return;
  //   }

  //   console.log("vscData in batch", csvData);
  //   const filteredData = csvData.filter((row) =>
  //     Object.values(row).some((item) => item && item.toString().trim() !== "")
  //   );

  //   let response = await ScheduleEntryAdd(
  //     merchantInfo.id,
  //     selectedDateTime,
  //     fileName,
  //     uploadLocation,
  //     uploadId,
  //     filteredData.length,
  //     notes,
  //     PIN
  //   );

  //   if (response.callStatus == 1) {
  //     setCsvData(null);
  //     setUploadId("0");
  //     setSuccuessfulSchedule(true);
  //   } else {
  //     if (response?.payload?.header?.callStatus == "0") {
  //       console.log(
  //         "response_errrr--------",
  //         response?.payload?.header?.callStatus
  //       );
  //       setAlert({
  //         open: true,
  //         severity: "error",
  //         message: response?.payload?.header?.msg,
  //         header: "Error!",
  //       });
  //     }
  //   }

  //   setScheduleBatch(true);
  // };
const submitBatch = async (e, PIN) => {
    if (isSubmittingRef.current) {
      console.warn("submitBatch already in progress — ignoring duplicate call");
      return;
    }
    isSubmittingRef.current = true;
    setPinProcessing(true);
    setSuccuessfulSchedule(false);
    
    // NOTE: PinPad stays open (loading=true) until we know the outcome.

    try {
      // ── Payroll category: use ScheduleEntryAdd3 + AddTransFileRecs workflow ──
      if (uploadId === PAYROLL_CATEGORY_ID) {
        await submitPayrollStyleBatch(PIN);
        return;
      }

      // ── All other categories: original ScheduleEntryAdd workflow (unchanged) ──
      if (fileName.split(".")[1] === "zip") {
        let response = await ScheduleEntryAdd(
          merchantInfo.id,
          selectedDateTime,
          fileName,
          uploadLocation,
          uploadId,
          1,
          notes,
          PIN,
          parseFloat(totalAmount) || 0 
        );
        if (response.callStatus == 1) {
          setUploadId("0");
          setSuccuessfulSchedule(true);
        } else {
          console.log("error---------", response);
        }
        setScheduleBatch(true);
        setShowPinPad(false);
        return;
      }

      console.log("vscData in batch", csvData);
      const filteredData = csvData.filter((row) =>
        Object.values(row).some((item) => item && item.toString().trim() !== "")
      );

      let response = await ScheduleEntryAdd(
        merchantInfo.id,
        selectedDateTime,
        fileName,
        uploadLocation,
        uploadId,
        filteredData.length,
        notes,
        PIN,
        parseFloat(totalAmount) || 0  
      );

      if (response.callStatus == 1) {
        setCsvData(null);
        setUploadId("0");
        setSuccuessfulSchedule(true);
      } else {
        if (response?.payload?.header?.callStatus == "0") {
          console.log(
            "response_errrr--------",
            response?.payload?.header?.callStatus
          );
          setAlert({
            open: true,
            severity: "error",
            message: response?.payload?.header?.msg,
            header: "Error!",
          });
        }
      }

      setScheduleBatch(true);
      setShowPinPad(false);
    } catch (err) {
      console.error("submitBatch error:", err);
      setAlert({
        open: true,
        severity: "error",
        header: "Error!",
        message: err?.message || "Something went wrong.",
      });
      setScheduleBatch(true);
      setShowPinPad(false);
    } finally {
      isSubmittingRef.current = false;
      setPinProcessing(false);
    }
};
  // ── Payroll-only submit workflow: mirrors SchedulePayrollBatch.jsx exactly ──
  // const submitPayrollStyleBatch = async (PIN) => {
  //   const isZip = fileName.toLowerCase().endsWith(".zip");
  //   const totalRecords = isZip ? 1 : (csvData ? csvData.length : 0);

  //   setUploadProgress({
  //     isUploading: true,
  //     processed: 0,
  //     total: totalRecords,
  //     message: "Scheduling batch...",
  //   });

  //   try {
  //     const scheduleResponse = await ScheduleEntryAdd(
  //       merchantInfo.id,
  //       selectedDateTime,
  //       fileName,
  //       uploadLocation,
  //       uploadId,
  //       1,
  //       notes,
  //       PIN,
  //       parseFloat(totalAmount) || 0, 
  //     );

  //     if (scheduleResponse.callStatus !== "1") {
  //       const msg = scheduleResponse?.payload?.msg?.toLowerCase() || "";
  //       if (
  //         msg.includes("pin") ||
  //         (scheduleResponse?.payload?.callStatus === "0" &&
  //           msg.includes("authentication"))
  //       ) {
  //         throw new Error("INCORRECT_PIN");
  //       }
  //       throw new Error(
  //         scheduleResponse?.payload?.header?.msg || "Failed to schedule batch",
  //       );
  //     }

  //     const requestid = scheduleResponse.requestid;

  //     setUploadProgress((prev) => ({
  //       ...prev,
  //       message: "Batch scheduled! Saving records...",
  //     }));

  //     let successCount = 0;
  //     let failCount = 0;

  //     if (!isZip && csvData && csvData.length > 0) {
  //       for (let i = 0; i < csvData.length; i++) {
  //         const row = csvData[i];

  //         const firstNameKey = Object.keys(row).find(
  //           (k) =>
  //             k.toLowerCase().includes("first") &&
  //             k.toLowerCase().includes("name"),
  //         );
  //         const lastNameKey = Object.keys(row).find(
  //           (k) =>
  //             k.toLowerCase().includes("last") &&
  //             k.toLowerCase().includes("name"),
  //         );
  //         const amountKey = Object.keys(row).find((k) =>
  //           k.toLowerCase().includes("amount"),
  //         );
  //         const emailKey = Object.keys(row).find((k) =>
  //           k.toLowerCase().includes("email"),
  //         );
  //         const phoneKey = Object.keys(row).find(
  //           (k) =>
  //             k.toLowerCase().includes("phone") ||
  //             k.toLowerCase().includes("mobile"),
  //         );
  //         const currencyKey = Object.keys(row).find((k) =>
  //           k.toLowerCase().includes("currency"),
  //         );
  //         const countryKey = Object.keys(row).find((k) =>
  //           k.toLowerCase().includes("country"),
  //         );
  //         const purposeKey = Object.keys(row).find((k) =>
  //           k.toLowerCase().includes("purpose"),
  //         );
  //         const birthdateKey = Object.keys(row).find(
  //           (k) =>
  //             k.toLowerCase().includes("birth") ||
  //             k.toLowerCase().includes("dob"),
  //         );
  //         const address1Key = Object.keys(row).find(
  //           (k) =>
  //             k.toLowerCase().includes("address") &&
  //             !k.toLowerCase().includes("2"),
  //         );
  //         const address2Key = Object.keys(row).find(
  //           (k) =>
  //             k.toLowerCase().includes("address2") ||
  //             k.toLowerCase().includes("address 2"),
  //         );
  //         const stateKey = Object.keys(row).find(
  //           (k) =>
  //             k.toLowerCase().includes("state") ||
  //             k.toLowerCase().includes("province"),
  //         );
  //         const zipKey = Object.keys(row).find(
  //           (k) =>
  //             k.toLowerCase().includes("zip") ||
  //             k.toLowerCase().includes("postal"),
  //         );
  //         const commentKey = Object.keys(row).find(
  //           (k) =>
  //             k.toLowerCase().includes("comment") ||
  //             k.toLowerCase().includes("note"),
  //         );

  //         const payload = {
  //           requestid,
  //           userid: merchantInfo.id,
  //           firstname: firstNameKey ? (row[firstNameKey] || "").trim() : "",
  //           lastname: lastNameKey ? (row[lastNameKey] || "").trim() : "",
  //           birthdate: birthdateKey ? (row[birthdateKey] || "").trim() : "",
  //           address1: address1Key ? (row[address1Key] || "").trim() : "",
  //           address2: address2Key ? (row[address2Key] || "").trim() : "",
  //           country: countryKey ? (row[countryKey] || "").trim() : "CA",
  //           state: stateKey ? (row[stateKey] || "").trim() : "",
  //           zipcode: zipKey ? (row[zipKey] || "").trim() : "",
  //           phoneno: phoneKey ? (row[phoneKey] || "").trim() : "",
  //           phoneno2: "",
  //           email: emailKey ? (row[emailKey] || "").trim() : "",
  //           currency: currencyKey ? (row[currencyKey] || "").trim() : "CAD",
  //           amount: amountKey
  //             ? (row[amountKey] || "").toString().replace(/,/g, "").trim() ||
  //               "0"
  //             : "0",
  //           comment: commentKey ? (row[commentKey] || "").trim() : "",
  //           purposeofaccount: purposeKey
  //             ? (row[purposeKey] || "").trim()
  //             : "SALARY",
  //           status: "Pending",
  //           errormessage: "",
  //         };

  //         try {
  //           const result = await AddTransFileRecs(payload);
  //           if (result?.callStatus === "1" || !result?.callStatus) {
  //             successCount++;
  //           } else {
  //             failCount++;
  //           }
  //         } catch (err) {
  //           failCount++;
  //         }

  //         setUploadProgress({
  //           isUploading: true,
  //           processed: i + 1,
  //           total: totalRecords,
  //           message: `Saving records... ${i + 1}/${totalRecords}`,
  //         });
  //       }
  //     }

  //     setAlert({
  //       open: true,
  //       severity: "success",
  //       header: "Batch Submitted!",
  //       message: `Request ID: ${requestid}\n${successCount} saved, ${failCount} failed.`,
  //     });

  //     setCsvData(null);
  //     setUploadId("0");
  //     setSuccuessfulSchedule(true);
  //     setScheduleBatch(true);
  //     setShowPinPad(false);   // ← add here
  //     setUploadProgress({
  //       isUploading: false,
  //       processed: 0,
  //       total: 0,
  //       message: "",
  //     });
  //   } catch (error) {
  //     if (error.message === "INCORRECT_PIN") {
  //       setAlert({
  //         open: true,
  //         severity: "error",
  //         header: "Incorrect PIN",
  //         message: "The PIN you entered is wrong. Please try again.",
  //       });
  //     } else {
  //       setAlert({
  //         open: true,
  //         severity: "error",
  //         header: "Error!",
  //         message: error.message || "Something went wrong.",
  //       });
  //     }
  //     setScheduleBatch(true);
  //     setUploadProgress({
  //       isUploading: false,
  //       processed: 0,
  //       total: 0,
  //       message: "",
  //     });
  //   }
  // };
  const submitPayrollStyleBatch = async (PIN) => {
    const isZip = fileName.toLowerCase().endsWith(".zip");
    const totalRecords = isZip ? 1 : (csvData ? csvData.length : 0);

    setUploadProgress({
      isUploading: true,
      processed: 0,
      total: totalRecords,
      message: "Scheduling batch...",
    });

    try {
      const scheduleResponse = await ScheduleEntryAdd3(
        merchantInfo.id,
        selectedDateTime,
        fileName,
        uploadLocation,
        uploadId,
        totalRecords,
        notes,
        PIN,
        parseFloat(totalAmount) || 0,
        merchantInfo.id,
        0,
        merchantInfo.id,
        originalFileName || fileName,
        "",
      );

      if (scheduleResponse.callStatus !== "1") {
        const msg = scheduleResponse?.payload?.msg?.toLowerCase() || "";
        if (
          msg.includes("pin") ||
          (scheduleResponse?.payload?.callStatus === "0" &&
            msg.includes("authentication"))
        ) {
          throw new Error("INCORRECT_PIN");
        }
        throw new Error(
          scheduleResponse?.payload?.header?.msg || "Failed to schedule batch",
        );
      }
      setShowPinPad(false);
      const requestid = scheduleResponse.requestid;

      setUploadProgress((prev) => ({
        ...prev,
        message: "Batch scheduled! Saving records...",
      }));

      let successCount = 0;
      let failCount = 0;
      const failedRecords = [];

      if (!isZip && csvData && csvData.length > 0) {
        for (let i = 0; i < csvData.length; i++) {
          const row = csvData[i];

          const firstNameKey = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("first") &&
              k.toLowerCase().includes("name"),
          );
          const lastNameKey = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("last") &&
              k.toLowerCase().includes("name"),
          );
          const amountKey = Object.keys(row).find((k) =>
            k.toLowerCase().includes("amount"),
          );
          const emailKey = Object.keys(row).find((k) =>
            k.toLowerCase().includes("email"),
          );
          const phoneKey = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("phone") ||
              k.toLowerCase().includes("mobile"),
          );
          const currencyKey = Object.keys(row).find((k) =>
            k.toLowerCase().includes("currency"),
          );
          const countryKey = Object.keys(row).find((k) =>
            k.toLowerCase().includes("country"),
          );
          const purposeKey = Object.keys(row).find((k) =>
            k.toLowerCase().includes("purpose"),
          );
          const birthdateKey = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("birth") ||
              k.toLowerCase().includes("dob"),
          );
          const address1Key = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("address") &&
              !k.toLowerCase().includes("2"),
          );
          const address2Key = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("address2") ||
              k.toLowerCase().includes("address 2"),
          );
          const stateKey = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("state") ||
              k.toLowerCase().includes("province"),
          );
          const zipKey = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("zip") ||
              k.toLowerCase().includes("postal"),
          );
          const commentKey = Object.keys(row).find(
            (k) =>
              k.toLowerCase().includes("comment") ||
              k.toLowerCase().includes("note"),
          );
          const accountNoKey = Object.keys(row).find(
            isExactAccountNumberHeader,
          );
          const accountno = accountNoKey
            ? String(row[accountNoKey] || "").trim()
            : "";
          const payload = {
            requestid,
            userid: merchantInfo.id,
            accountno,
            firstname: firstNameKey ? (row[firstNameKey] || "").trim() : "",
            lastname: lastNameKey ? (row[lastNameKey] || "").trim() : "",
            birthdate: birthdateKey ? (row[birthdateKey] || "").trim() : "",
            address1: address1Key ? (row[address1Key] || "").trim() : "",
            address2: address2Key ? (row[address2Key] || "").trim() : "",
            country: countryKey ? (row[countryKey] || "").trim() : "CA",
            state: stateKey ? (row[stateKey] || "").trim() : "",
            zipcode: zipKey ? (row[zipKey] || "").trim() : "",
            phoneno: phoneKey ? (row[phoneKey] || "").trim() : "",
            phoneno2: "",
            email: emailKey ? (row[emailKey] || "").trim() : "",
            currency: currencyKey ? (row[currencyKey] || "").trim() : "CAD",
            amount: amountKey
              ? (row[amountKey] || "").toString().replace(/,/g, "").trim() ||
                "0"
              : "0",
            comment: commentKey ? (row[commentKey] || "").trim() : "",
            purposeofaccount: purposeKey
              ? (row[purposeKey] || "").trim()
              : "SALARY",
            status: "Pending",
            errormessage: "",
          };

          try {
            const result = await AddTransFileRecs(payload);
            if (String(result?.callStatus) === "1") {
              successCount++;
            } else {
              failCount++;
              const serviceError =
                result?.payload?.msg ||
                result?.payload?.message ||
                result?.msg ||
                "The record was not accepted by the payroll service.";
              failedRecords.push({
                row: i + 2,
                message: String(serviceError)
                  .replace(/&lt;/g, "<")
                  .replace(/&gt;/g, ">")
                  .replace(/&amp;/g, "&")
                  .replace(/<[^>]*>/g, " ")
                  .replace(/\s+/g, " ")
                  .trim(),
              });
            }
          } catch (err) {
            failCount++;
            failedRecords.push({
              row: i + 2,
              message:
                err?.response?.data?.payload?.msg ||
                err?.message ||
                "The record could not be saved.",
            });
          }

          setUploadProgress({
            isUploading: true,
            processed: i + 1,
            total: totalRecords,
            message: `Saving records... ${i + 1}/${totalRecords}`,
          });
        }
      }

      if (failCount > 0) {
        setValidationErrors(
          failedRecords.map((record) => ({
            message: `Row ${record.row}: ${record.message}`,
          })),
        );
        setAlert({
          open: true,
          severity: "error",
          header: "Payroll Records Could Not Be Saved",
          message:
            `Request ID: ${requestid}\n${successCount} saved, ${failCount} failed. ` +
            "The batch was scheduled, but it is incomplete. Fix the listed records before continuing.",
        });
        setSuccuessfulSchedule(false);
        setScheduleBatch(true);
        setUploadProgress({ isUploading: false, processed: 0, total: 0, message: "" });
        return;
      }

      setAlert({
        open: true,
        severity: "success",
        header: "Batch Submitted!",
        message: `Request ID: ${requestid}\n${successCount} saved, ${failCount} failed.`,
      });

      setCsvData(null);
      setOriginalFileName("");
      setUploadId("0");
      setSuccuessfulSchedule(true);
      setScheduleBatch(true);
      setShowPinPad(false);
      setUploadProgress({
        isUploading: false,
        processed: 0,
        total: 0,
        message: "",
      });
    } catch (error) {
      if (error.message === "INCORRECT_PIN") {
        setAlert({
          open: true,
          severity: "error",
          header: "Incorrect PIN",
          message: "The PIN you entered is wrong. Please try again.",
        });
      } else {
        setAlert({
          open: true,
          severity: "error",
          header: "Error!",
          message: error.message || "Something went wrong.",
        });
      }
      setScheduleBatch(true);
      setShowPinPad(false);
      setUploadProgress({
        isUploading: false,
        processed: 0,
        total: 0,
        message: "",
      });
    }
};
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      console.log("No file selected.");
      return;
    }

    if (uploadId === "0") {
      setAlert({
        open: true,
        severity: "error",
        header: "Batch Category Required",
        message: "Please select a batch category before uploading a file.",
      });
      event.target.value = null;
      return;
    }

    // ── Reset all prior state so the UI is clean for the new file ──
    setCsvData(null);
    setValidationErrors([]);
    setFileName("");
    setOriginalFileName(file.name);

    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    const reader = new FileReader();
    const form_data = new FormData();
    form_data.append("file", file);
    const postUrl = getBaseUrl(serviceUrl);

    if (fileExtension !== "csv") {
      setAlert({
        open: true,
        severity: "error",
        message:
          "This file extension is not accepted. Please upload a CSV file.",
        header: "Invalid File Format",
      });
      event.target.value = null;
      return;
    }
      // ── Duplicate-file check (ScheduleJobList6) ──────────────────────────
  // Compare the selected filename against scheduleinstance.originalfilename.
  const normalizedFileNameForCheck = file.name.replace(/(\.csv)+$/i, ".csv");

  try {
    const dupCheckResponse = await ScheduleJobList6({
      location: "",
      rows: 0,
      requestid: 0,
      userid: 0,
      categoryid: 0,
      executionstatus: "",
      originalfilename: normalizedFileNameForCheck,
    });

    if (dupCheckResponse?.data?.header?.callStatus === "1") {
      setAlert({
        open: true,
        severity: "error",
        header: "File Already Exists",
        message: `Please rename the file or check existing batches before re-uploading.`,
      });
      event.target.value = null;
      return;
    }
  } catch (dupErr) {
    // Fail-open: if the duplicate-check call itself errors, don't block the user
    console.error("ScheduleJobList6 duplicate check failed:", dupErr);
  }
    reader.onload = async (e) => {
      Papa.parse(e.target.result, {
        header: true,
        skipEmptyLines: true,
        complete: async function (results) {
          const actualHeaders = results.meta?.fields || [];

          if (uploadId !== "21" && uploadId !== "2") {
            const { unexpected, missing, duplicates } =
              getTemplateHeaderErrors(actualHeaders);

            if (unexpected.length > 0 || missing.length > 0 || duplicates.length > 0) {
              const details = [
                missing.length > 0 && `Missing: ${missing.join(", ")}`,
                unexpected.length > 0 && `Invalid: ${unexpected.join(", ")}`,
                duplicates.length > 0 && `Duplicate: ${duplicates.join(", ")}`,
              ]
                .filter(Boolean)
                .join("\n");
              setAlert({
                open: true,
                severity: "error",
                header: "Invalid Payroll Template",
                message:
                  `Header names must exactly match the payroll template.\n${details}\n\nPlease download and use the latest payroll template.`,
              });
              setCsvData([]);
              setValidationErrors([]);
              setFileName("");
              setOriginalFileName("");
              return;
            }
          }

          const parsedData = results.data.filter((row) =>
            Object.values(row).some(
              (cell) => cell && cell.toString().trim() !== ""
            )
          );
          setCsvData(parsedData);

          let invalidEmailsRow = [];
          parsedData.forEach((row, index) => {
            const email = row["email"];
            if (!isValidEmail(email)) {
              invalidEmailsRow.push(index + 2);
            }
          });
          setInvalidEmails(invalidEmailsRow);

          // ── Payroll validation on upload ──
          let errors = [];
          if (uploadId !== "21" && uploadId !== "2") {
            try {
              const referenceData = await getValidationReferenceData();
              errors = validateCsvData(parsedData, referenceData);
            } catch (error) {
              console.error("Payroll reference-data lookup failed:", error);
              errors = [{
                message:
                  "Could not load the current currency and country validation data. Please try uploading the file again.",
              }];
            }
          }

          if (
            uploadId !== "21" &&
            uploadId !== "2" &&
            errors.length === 0
          ) {
            try {
              errors.push(...(await getPhoneEmailMismatchErrors(parsedData)));
            } catch (error) {
              console.error("Phone-account lookup failed:", error);
              errors.push({
                message:
                  "Could not verify the existing phone account details. Please try uploading the file again.",
              });
            }
            try {
              errors.push(...(await getAccountContactMismatchErrors(parsedData)));
            } catch (error) {
              console.error("Account-contact lookup failed:", error);
              errors.push({
                message:
                  "Could not verify the existing account details. Please try uploading the file again.",
              });
            }
          }
          setValidationErrors(errors);

          if (errors.length > 0) {
            setAlert({
              open: true,
              severity: "warning",
              header: `${errors.length} Issue${errors.length === 1 ? "" : "s"} Found`,
              message:
                "Please review and fix the validation issues before scheduling.",
            });
          }
        },
      });

      try {
        const response = await fetch(postUrl + "/uploadbatch.php", {
          method: "POST",
          body: form_data,
        });

        if (response.ok) {
          const responseData = await response.json();
          setFileName(responseData.newfilename);
        } else {
          console.error("Error:", response.status, response.statusText);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    reader.readAsText(file);
  };

  console.log(csvData);

  const handleScheduleClick = async () => {
    if (uploadId === "0") {
      setAlert({
        open: true,
        severity: "error",
        message: "Please select a batch category before scheduling.",
        header: "Batch Category Required",
      });
      return;
    }

    if (!fileName) {
      setAlert({
        open: true,
        severity: "error",
        message: "Please upload a file",
        header: "Error!",
      });
      return;
    }

    if (!csvData || csvData.length === 0) {
      setAlert({
        open: true,
        severity: "error",
        message:
          "No records found in the batch file. Please add at least one employee record before scheduling the batch.",
        header: "Error!",
      });
      return;
    }

    // Re-run validation at schedule time
    let errors = [];
    if (uploadId !== "21" && uploadId !== "2") {
      try {
        const referenceData = await getValidationReferenceData();
        errors = validateCsvData(csvData, referenceData);
      } catch (error) {
        console.error("Payroll reference-data lookup failed:", error);
        errors = [{
          message:
            "Could not load the current currency and country validation data. Please try scheduling the batch again.",
        }];
      }
    }
    setValidationErrors(errors);

    if (errors.length > 0) {
      const firstFive = errors.slice(0, 5);
      const remaining = errors.length - 5;
      const messageLines = firstFive.map((e) => `• ${e.message}`).join("\n");
      const finalMessage =
        remaining > 0
          ? `${messageLines}\n• ... and ${remaining} more issue(s).`
          : messageLines;

      setAlert({
        open: true,
        severity: "error",
        header: "Cannot Schedule Batch",
        message: `Please fix the ${errors.length} validation issue(s) in the file:\n${finalMessage}`,
      });
      return;
    }

    setShowPinPad(true);
  };

  const handleConfirm = (event, pin) => {
    let PIN = pin.join("");
    submitBatch(event, PIN);
    // setShowPinPad(false);
  };

  return (
    <Box className="schedule-batch-container">
      <Box className="schedule-batch">
        <Box className="scheduler-container">
          <Box className="selector-width">
            <Box className="batch-text">Scheduler Mode</Box>
            <Box>
              <select
                className="batch-select"
                value={uploadId}
                onChange={handleBatchTypeChange}
                required
                aria-required="true"
              >
                <option value="0" disabled>
                  Select batch type
                </option>
                {[...batchList]
                  .filter(
                    (item) =>
                      String(item?.batchfilecategories?.categoryid) !== "33",
                  )
                  .sort((a, b) =>
                    a.batchfilecategories.categoryname
                      .replace(/&amp;/g, "&")
                      .localeCompare(
                        b.batchfilecategories.categoryname.replace(
                          /&amp;/g,
                          "&"
                        )
                      )
                  )
.map((item) => (
                    <option
                      key={item.batchfilecategories.categoryid}
                      value={item.batchfilecategories.categoryid}
                    >
                      {item.batchfilecategories.categoryname.replace(
                        /&amp;/g,
                        "&"
                      )}
                    </option>
                  ))}
              </select>
            </Box>
          </Box>

          <Box className="selector-width">
            <Box className="batch-text">Scheduler Date/Time</Box>
            <Box>
              <input
                className="batch-date"
                type="datetime-local"
                value={selectedDateTime}
                onChange={handleDateTimeChange}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className="upload-container">
        {/* ─── Two-column row: upload label + file input LEFT, file notes RIGHT ─── */}
        <Box className="scheduler-container">
          <Box className="selector-width">
            <Box className="batch-text">
              Upload your batch file here by clicking choose file or dragging
              the file into the input box.
              <br />
              <span className="download-link">
                {uploadId == "21" || uploadId == "2" ? (
                  <a
                    className="download-link"
                    href={templateUrl + "/batch_template_physical_card.xlsx"}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Download the batch template.
                  </a>
                ) : (
                  <span
  className="download-link"
  onClick={handleDownloadTemplate}
  style={{ cursor: "pointer" }}
>
  Download the batch template.
</span>
                )}
              </span>
              {uploadId !== "21" && uploadId !== "2" && (
                <span className="template-update-notice" role="status">
                  <InfoOutlinedIcon fontSize="small" aria-hidden="true" />
                  Please use the latest template (includes the Account Number column).
                </span>
              )}
            </Box>
            <Box className="upload-file-container">
              {/* ── File input: hidden once a file is chosen ── */}
              <input
                id="batchfilecsv"
                type="file"
                size="50"
                accept=".csv"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: fileName ? "none" : "block" }}
              />

              {/* ── "Change File" button: visible only after a file has been uploaded ── */}
              {fileName && (
                <button
                  className="change-file-btn"
                  onClick={() => {
                    if (fileInputRef.current) {
                      fileInputRef.current.value = "";
                      fileInputRef.current.click();
                    }
                  }}
                >
                  Change File
                </button>
              )}
            </Box>
          </Box>

          <Box className="selector-width">
            <br />
            <Box className="batch-text">File Notes</Box>
            <Box>
              <input
                className="batch-date"
                type="text"
                placeholder="(optional)"
                value={notes}
                onChange={handleChange}
              />
            </Box>
          </Box>
        </Box>

        {/* ─── INSTRUCTION BANNER ─── */}
        <Box
          sx={{
            mt: 1.5,
            mb: 1,
            px: 2,
            py: 1.5,
            backgroundColor: "#E6F1FB",
            border: "0.5px solid #B5D4F4",
            borderRadius: 2,
            display: "flex",
            gap: 1,
            alignItems: "flex-start",
          }}
        >
          <InfoOutlinedIcon
            sx={{ fontSize: 16, color: "#185FA5", mt: "2px", flexShrink: 0 }}
          />
          <Box>
            <Typography
              sx={{ fontSize: 13, fontWeight: 500, color: "#0C447C", mb: 0.25 }}
            >
              How to prepare your file
            </Typography>
            <Box
              component="ol"
              sx={{
                fontSize: 13,
                color: "#185FA5",
                m: 0,
                pl: 2,
                lineHeight: 1.8,
              }}
            >
              <li>Download the batch template above</li>
              <li>
                Open it in <strong>Microsoft Excel</strong>
              </li>
              <li>Fill in your employee and payroll data</li>
              <li>
                Save / export as <strong>.csv format</strong> before uploading
              </li>
            </Box>
          </Box>
        </Box>
        {/* ─── END INSTRUCTION BANNER ─── */}

        <Box className="succuessful-schedule">
          {succuessfulSchedule
            ? "Your batch has been succuessfully scheduled"
            : null}
        </Box>
      </Box>

      {/* ─── VALIDATION ERRORS PANEL ─── */}
      {validationErrors.length > 0 && (
        <Box
          sx={{
            my: 3,
            p: 3,
            backgroundColor: "#fff3cd",
            border: "1px solid #ffeaa7",
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" color="#856404">
            {validationErrors.length} Validation Issue(s) Found
          </Typography>
          <Box sx={{ mt: 1, maxHeight: "300px", overflowY: "auto", pr: 1 }}>
            <Typography
              variant="body2"
              color="#856404"
              component="div"
              sx={{ whiteSpace: "pre-line" }}
            >
              {validationErrors.map((e) => `• ${e.message}`).join("\n")}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            color="#856404"
            sx={{ mt: 2, fontWeight: "bold" }}
          >
            Please fix the highlighted rows before submitting.
          </Typography>
        </Box>
      )}
      {/* ─── END VALIDATION ERRORS PANEL ─── */}

      {/* ─── PAYROLL-ONLY SUBMIT PROGRESS (ScheduleEntryAdd3 + AddTransFileRecs loop) ─── */}
      {uploadId === PAYROLL_CATEGORY_ID && uploadProgress.isUploading && (
        <Box
          sx={{
            mt: 3,
            p: 3,
            backgroundColor: "#5523D2",
            color: "white",
            borderRadius: 2,
            textAlign: "center",
            fontSize: "1.1rem",
          }}
        >
          <CircularProgress size={30} sx={{ color: "white", mb: 2 }} />
          <Typography variant="h6">{uploadProgress.message}</Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            {uploadProgress.processed} / {uploadProgress.total} records
          </Typography>
          <Box
            sx={{
              width: "80%",
              bgcolor: "rgba(255,255,255,0.3)",
              borderRadius: 2,
              height: 10,
              mx: "auto",
              mt: 2,
            }}
          >
            <Box
              sx={{
                width: `${(uploadProgress.processed / uploadProgress.total) * 100 || 0}%`,
                bgcolor: "white",
                height: "100%",
                borderRadius: 2,
                transition: "width 0.3s ease",
              }}
            />
          </Box>
        </Box>
      )}
      {/* ─── END PAYROLL-ONLY SUBMIT PROGRESS ─── */}

      <Box className="schedule-batch-button-container">
        <button
          onClick={handleScheduleClick}
          disabled={
            (uploadId === PAYROLL_CATEGORY_ID && uploadProgress.isUploading)
          }
        >
          {uploadId === PAYROLL_CATEGORY_ID && uploadProgress.isUploading
            ? "Scheduling..."
            : "Schedule Batch"}
        </button>
      </Box>

      <Box className="csv-table-container">
        {csvData && csvData.length > 0 && (
          <Box className="csv-data-container">
            <Box>Users: {csvData ? csvData.length : 0}</Box>
            <table className="upload-table">
              <thead>
                <tr>
                  {csvData.length > 0 &&
                    Object.keys(csvData[0]).map((header, index) => (
                      <th key={index}>{header}</th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {csvData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {Object.values(row).map((cell, cellIndex) => (
                      <td key={cellIndex}>{cell}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        )}
      </Box>

      {showPinPad && (
        <PinPad
          show={showPinPad}
          handleConfirm={handleConfirm}
          onClick={() => {
      if (pinProcessing) return; // don't let the user dismiss it mid-request
      setShowPinPad(false);
    }}
    loading={pinProcessing}
        />
      )}

      <CustomAlert
        severity={alert.severity}
        show={alert.open}
        header={alert.header}
        message={alert.message}
        onClick={() => setAlert((prev) => ({ ...prev, open: false }))}
        autoclose={alert.severity === "error" ? false : true}
      />
    </Box>
  );
}


export default ScheduleBatch;
